<template>
  <div>
    <b-row class="border-bottom mb-2">
      <b-col>
        <h4 class="mb-0">
          Assign Object to Site
        </h4>
        <small class="text-muted">
          Don't have any sites in the workspace yet? Do not worry, you can later assign the object to a site
        </small>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Site Name"
          label-for="site-name"
        >
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            :options="sites"
            @input="setSelected"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <div
      v-if="selected"
      class=" mb-2"
    >

      <b-row>
        <b-col>
          <h4 class="mt-2 border-bottom">
            Site Details
          </h4>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <p><b>Name:</b></p>
          <kbd>{{ selected.name }}</kbd>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <p><b>Address:</b></p>
          <kbd>{{ selected.address }}</kbd>
        </b-col>
        <b-col>
          <p><b>City:</b></p>
          <kbd>{{ selected.city }}</kbd>
        </b-col>
        <b-col>
          <p><b>Sub Region:</b></p>
          <kbd>{{ selected.subRegion }}</kbd>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="4">
          <p><b>Region:</b></p>
          <kbd>{{ selected.region }}</kbd>
        </b-col>
        <b-col>
          <p><b>Country:</b></p>
          <kbd>{{ selected.country }}</kbd>
        </b-col>
      </b-row>

      <b-row
        v-if="selected"
        class="mt-2 mb-2"
      >
        <b-col>
          <add-object-site-map
            :site="selected"
          />
        </b-col>
      </b-row>

    </div>

  </div>
</template>

<script>
import {
  BCol,
  BRow,
  BFormGroup,

} from 'bootstrap-vue'
import vSelect from 'vue-select'
import AddObjectSiteMap from './AddObjectSiteMap.vue'

export default {
  components: {
    BCol,
    BRow,
    BFormGroup,
    AddObjectSiteMap,

    vSelect,
  },
  props: {
    newObject: {
      type: Object,
      default: () => {},
    },
    sites: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: null,
    }
  },
  methods: {
    setSelected(selected) {
      this.selected = null
      this.selected = selected
      this.newObject.site = selected
    },
  },

}
</script>

<style>

</style>
